module.exports = __webpack_public_path__ + "static/media/happy2.be2da6ec.svg";